import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { type BadgeProps } from './Badge';

type BadgeIconProps = ComponentProps<'div'> & Pick<BadgeProps, 'size'>;

export default function BadgeText({ size, children, className, ...props }: BadgeIconProps) {
  return (
    <span
      className={cn(
        'py-0.5 first:pl-2 last:pr-2',
        {
          'py-0.25 text-xs first:pl-1.5 last:pr-1.5': size === 'sm',
          'py-0.25 text-3xs first:pl-1 last:pr-1': size === 'xs',
        },
        className,
      )}
      {...props}>
      {children}
    </span>
  );
}
